export default __webpack_public_path__ + "static/media/DiabetesInfog.8a619169.png";